import { blenderCss, BlendMode } from '@cld/blender';
import { Variant } from '@cld/design-system-foundations';
import { ItemPureProps, SelectionVariant } from './types';

export const getBlendMode = (selectionVariant: SelectionVariant, isSelected: boolean, variant: Variant): BlendMode => {
  if (isSelected) {
    return selectionVariant === 'solid' ? 'solidContrast' : 'plainSolid';
  }
  return variant === 'primary' ? 'surfaceContrast' : 'plainSolid';
};

const intensityByState = {
  normal: 'md',
  hover: 'sm',
  selected: 'lg',
  selectedHover: 'xl',
} as const;

export const populateBlenderVariablesForState = (state: keyof typeof intensityByState) => ({
  variant,
  selectionVariant,
  isSelected,
}: Pick<ItemPureProps, 'variant' | 'selectionVariant' | 'isSelected'>) => {
  const mode = getBlendMode(selectionVariant, isSelected, variant);

  return blenderCss.populateVariables({ mode, variant, intensity: intensityByState[state] });
};
